import React from 'react';

const UpperLeftBlock = ({ setShowCreateNewFlowModal }) => {
  return (
    <div className="my-flows-upper-left">
      <h2 className="my-flows-upper-left-title">
        <span className="my-flows-upper-left-title-highlight">MIX</span> — Объединяем трафик
      </h2>
      <p className="my-flows-upper-left-subtitle">
        Протестируйте все возможности
        нашего сервиса с помощью <span className="my-flows-upper-left-title-highlight">потока MIX</span>
      </p>
      <button className="btn btn-primary-filled" onClick={() => setShowCreateNewFlowModal(true)}>Подключить поток</button>
    </div>
  );
};

export default UpperLeftBlock;